<template>
  <Input v-maska:unmaskedValue.unmasked="options" v-model="maskedValue" placeholder="+1 (999) 999-9999" />
</template>

<script setup lang="ts">
import { MaskInputOptions } from 'maska';
import { vMaska } from 'maska/vue';
import { reactive, ref, watch } from 'vue';

import Input from './input.vue';

const maskedValue = ref();
const unmaskedValue = defineModel<string | undefined | null>();

const options = reactive<MaskInputOptions>({
  mask: '+1 (###) ###-####',
  eager: false,
});

watch(
  unmaskedValue,
  () => {
    maskedValue.value = unmaskedValue.value;
  },
  { immediate: true },
);

defineExpose({ unmaskedValue });
</script>

<style scoped></style>
